import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { UnitPcvForm } from '../models/unitPcv';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';

const unitPcvSchema = yup
  .object({
    name: yup.string().required('El nombre es requerido.'),
    model_name: yup.string().required('El nombre del modelo es requerido.'),
    area: yup
      .number()
      .positive('El área debe ser mayor a cero.')
      .required('El área es requerida.'),
    initial_base_price: yup
      .number()
      .positive('El precio inicial debe ser mayor a cero.')
      .required('El precio inicial es requerido.'),
    base_price: yup
      .number()
      .positive('El precio base debe ser mayor a cero.')
      .required('El precio base es requerido.'),
    square_rods: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .default(0),
    bathrooms: yup
      .number()
      .positive('La cantidad de baños debe ser mayor a cero.')
      .required('La cantidad de baños base es requerido.'),
    bedrooms: yup
      .number()
      .positive('La cantidad de habitaciones debe ser mayor a cero.')
      .required('La cantidad de habitaciones base es requerido.'),
    parking: yup
      .number()
      .positive('La cantidad de parqueos debe ser mayor a cero.')
      .required('La cantidad de parqueos base es requerido.'),
    level: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .default(0),
    landlord_id: yup.string().nullable(),
    distribution: yup.string().nullable(),
    unit_tags: yup.array().of(yup.string()),
    unit_amenities: yup.array().of(yup.string()),
    status: yup.string().nullable(),
  })
  .required();

const useManageUnitPcvForm = (unitPcv?: UnitPcvForm) => {
  const { isLoading } = useCallApiAndLoad();
  const [error, setError] = useState<string | null>(null);

  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm<UnitPcvForm>({
    resolver: yupResolver(unitPcvSchema),
  });

  return {
    handleSubmit,
    errors,
    control,
    setValue,
    isLoading,
    error,
    setError,
    isEditing: !!unitPcv,
    unitPcv,
    reset,
  };
};

export default useManageUnitPcvForm;
